// Ikonerna i menyn, från designen. De är dekoration, så texten bredvid bär betydelsen.
import type { ReactNode } from 'react';

function Ikon({ children }: { children: ReactNode }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const ikoner = {
  inkorg: (
    <Ikon>
      <path d="M3 13h5l2 3h4l2-3h5" />
      <path d="M5 5h14l2 8v6H3v-6z" />
    </Ikon>
  ),
  katalog: (
    <Ikon>
      <path d="M9 6h11M9 12h11M9 18h11" />
      <path d="M4 6h.01M4 12h.01M4 18h.01" />
    </Ikon>
  ),
  testlage: (
    <Ikon>
      <path d="M9 3h6M10 3v6L4.5 19a1.5 1.5 0 0 0 1.3 2h12.4a1.5 1.5 0 0 0 1.3-2L14 9V3" />
    </Ikon>
  ),
  offertmall: (
    <Ikon>
      <path d="M6 3h9l4 4v14H6z" />
      <path d="M14 3v5h5M9 13h7M9 17h5" />
    </Ikon>
  ),
  utskick: (
    <Ikon>
      <path d="M21 3 10 14" />
      <path d="m21 3-7 18-4-7-7-4z" />
    </Ikon>
  ),
  uppfoljning: (
    <Ikon>
      <path d="M20 11a8 8 0 0 0-14.6-4.5L4 8" />
      <path d="M4 3v5h5" />
      <path d="M4 13a8 8 0 0 0 14.6 4.5L20 16" />
      <path d="M20 21v-5h-5" />
    </Ikon>
  ),
  formular: (
    <Ikon>
      <path d="m8 8-4 4 4 4M16 8l4 4-4 4" />
    </Ikon>
  ),
  anvandare: (
    <Ikon>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5M16 4.8a3.5 3.5 0 0 1 0 6.4M18.5 14.8c1.6.8 2.6 2.5 3 5.2" />
    </Ikon>
  ),
  abonnemang: (
    <Ikon>
      <rect x="2.5" y="5" width="19" height="14" rx="2" />
      <path d="M2.5 9.5h19M6 15h4" />
    </Ikon>
  ),
  resurser: (
    <Ikon>
      <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z" />
      <path d="M4 20.5A2.5 2.5 0 0 0 6.5 23H20v-5M8 7h8M8 11h6" />
    </Ikon>
  ),
};

/** LeadLedgers märke. */
export function Marke({ storlek = 26 }: { storlek?: number }) {
  return (
    <svg width={storlek} height={storlek} viewBox="0 0 28 28" aria-hidden="true">
      <rect width="28" height="28" rx="7" fill="#1E5E46" />
      <path d="M8 9h12M8 13.5h8" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 18.5h12M8 21.5h12" stroke="#BFE0CB" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
